import Highcharts from 'highcharts';
Highcharts.setOptions({
	lang: {
		      decimalPoint: ','
	      }
});
export const figure55 = {
  chart: {
      zoomType: 'xy',
      animation: false,
      marginTop: 50,
      marginLeft: 180,
      plotBackgroundColor: null,
      plotBorderWidth: null,
      plotShadow: false,
      type: 'bar',
      height: '600px',
      backgroundColor: 'rgba(255, 255, 255, 0.0)',
      style: {
        fontFamily: 'Montserrat'
      }
    },

    colors: ['#a5a5a5', '#599cd5'],

    credits: {
      enabled: false
    },
    title: {
      text: null
    },
    subtitle: {
      text: null
    },

    plotOptions: {
      series: {
        borderWidth: 0,
        marker: {
          symbol: 'circle',
          enabled: false,
          states: {
            hover: {
              enabled: true,
              radius: 5
            }
          }
        }
      }
    },

    exporting: {
      enabled: false
    },

    xAxis: [{
      categories: [
        "Monde",
        "",
        "Australie et Nouvelle-Zélande*",
        "Europe et Amérique du Nord",
        "Afrique du Nord et Asie de l’Ouest",
        "Amérique latine et Caraïbes",
        "Asie de l’Est et du Sud-Est ",
        "Asie centrale et du Sud",
        "Océanie (hors Australie et Nouvelle-Zélande)",
        "Afrique subsaharienne ",
        "",
        "Pays les moins avancés",
        "Petits États insulaires en développement",
      ],
      lineColor: "#d7d7d7",
      tickColor: "#d7d7d7",
      tickLength: 16,
      labels: {
        style: {
          fontWeight: 'normal',
          color: '#999999',
          fontSize: '12px'
        }
      },
    }],
    yAxis: [{
      labels: {
        	format: '{value}',
        style: {
          fontWeight: 'normal',
          color: '#999999',
          fontSize: '12px'
        },
      },
      max: 5,
      min: 1,
      tickInterval: 1,
      gridLineWidth: 0,
      title: {
        text: null,
        style: {
          color: Highcharts.getOptions().colors[1]
        }
      }
    }],
    tooltip: {
      shared: true,
      useHTML: true,
      hideDelay: 500,
      backgroundColor: null,
      borderWidth: 0,
      shadow: false,
      style: {
        padding: 0
      }
    },
    legend: {
      enabled: false,
    },

    series: [{
    name: '2022',
      tooltip: {
        valueSuffix: '%'
      },
      dataLabels: {
        enabled: false,
        style: {
          fontWeight: 'normal',
          textOutline: false,
          color: '#999999',
          fontSize: '12px'
        }
      },
      data: [
	   4,
	   0,
	   0,
	   5,
	   4,
	   4,
	   4,
	   3,
	   4,
	   3,
	   0,
	   3,
	   4,
      ]
    },{
        name: '2018',
      tooltip: {
        valueSuffix: '%'
      },
      dataLabels: {
        enabled: false,
        style: {
          fontWeight: 'normal',
          textOutline: false,
          color: '#999999',
          fontSize: '12px'
        }
      },
      data: [
	     3,
	     0,
	     5,
	     5,
	     3,
	     3,
	     4,
	     3,
	     4,
	     4,
	     0,
	     3,
	     3,
      ],
    }]
}
